import React, { useEffect, useState } from "react";
import MainBanner from "../../Components/Banner/MainBanner";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import "../../assets/css/GardenTour.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { arrow, dollar } from "../../constant";
import StripeForm from "../../Components/PaymentMethod/StripeForm";
import ActionButton from "../../Components/ActionBtn/ActionButton";
import { useDispatch, useSelector } from "react-redux";
import {
  bookMemberShipPost,
  GetMembership,
  GetExtraCharges,
  GetMembershipBook,
  PostMembershipById,
} from "../../network/Network";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

function GardenTour() {
  const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
  const Token = useSelector((state) => state?.AuthReducer?.token);
  const new_date = new Date().toISOString().slice(0, 10);
  const navigate = useNavigate();
  const dispatch = useDispatch;
  const [gardenMembership, setGardenMembership] = useState([]);
  const [membershipId, setMembershipId] = useState();
  const [camping, setCamping] = useState();
  const [state, setState] = useState({
    membership_id: 1,
    is_family_membership: "",
    other_memberships_included: "",
    price: gardenMembership?.price,
    booking_date: "",
    booking_time: "",
  });
  const [loading, setLoading] = useState(true);
  const [singleCamping, setSingleCamping] = useState();
  const [membershipError, setMembershipError] = useState();

  const styling = {
    marginTop: "10px",
    width: "100%",
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (state.other_memberships_included) {
      let value = camping?.filter((item) => {
        if (item?.type === "garden_tour") return item;
      });
      setSingleCamping(value?.[0]);
    }
  }, [state.other_memberships_included]);

  // Get Membership by id
  useEffect(() => {
    setLoading(true);
    PostMembershipById(1)
      .then((res) => {
        setGardenMembership(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);
  useEffect(() => {
    setLoading(true);
    GetMembershipBook()
      .then((res) => {
        setCamping(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    GetExtraCharges()
      .then((res) => {
        setMembershipId(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const PlaceOrderHandler = (e, stripe_token) => {
    setLoading(true);
    e.preventDefault();
    if (!state?.booking_date || !state?.booking_time) {
      toast.error("Plese fill all compulsory fields");
      setLoading(false);
    } else {
      let sendData = {
        membership_id: state?.membership_id,
        is_family_membership: state?.is_family_membership,
        // other_memberships_included: state?.other_memberships_included
        //   ? singleCamping?.id
        //   : null,
        other_memberships_included: state?.other_memberships_included ?? null,
        price: state?.other_memberships_included
          ? `${
              parseInt(singleCamping?.price) + parseInt(gardenMembership?.price)
            }`
          : gardenMembership?.price,
        _token: stripe_token,
        booking_date: state?.booking_date,
        booking_time: state?.booking_time,
        type: "booking",
      };
      bookMemberShipPost(sendData, Token)
        .then((res) => {
          setLoading(false);
          if (res?.data?.error) {
            toast?.error(res?.data?.error);
            return;
          }
          navigate("/");
          toast.success("Garden tour booking has been done successfully");
        })
        .catch((err) => {
          toast.error(`${err?.response?.data?.message}`);
          setLoading(false);
        });
    }
  };

  return (
    <>
      <Header />
      <MainBanner name={"Garden Tour"} />
      <section className="GardenTour-page">
        <div className="container">
          {loading ? (
            <Skeleton count={5} />
          ) : (
            <div>
              <div className="Book_range_center">
                <h2 className="main-Title">Book 1 Day Tour </h2>
                <h3 className="priceRate">
                  <img src={dollar} alt="" />
                  {
                    <span className="ml-2">
                      {state?.other_memberships_included
                        ? `${
                            parseInt(singleCamping?.price) +
                            parseInt(gardenMembership?.price)
                          }`
                        : gardenMembership?.price}
                    </span>
                  }
                </h3>
              </div>
              <p className="main-para">{gardenMembership?.description}</p>
              <ActionButton />

              <div className="formContainer">
                <p className="sub-title">Booking Details</p>
                <div className="row">
                  <div className="col-lg-6">
                    <p className="sub-title-sm">Select the Date</p>
                    <input
                      min={new_date}
                      onKeyDown={(e) => e.preventDefault()}
                      onChange={(e) => {
                        setState({ ...state, booking_date: e.target.value });
                      }}
                      type="date"
                    />
                  </div>
                  <div className="col-lg-6">
                    <p className="sub-title-sm">Select Check-in Time</p>
                    <input
                      onChange={(e) => {
                        setState({ ...state, booking_time: e.target.value });
                      }}
                      type="time"
                    />
                  </div>
                  <div className="col-lg-6 addCampingRadio">
                    <div className="row">
                      {/* <div className="col-md-2 centerRadioBtn"></div> */}
                      <div className="col-md-12">
                        <p className="sub-title-sm with_check">
                          <input
                            onChange={(e) => {
                              const gardenTourObj = membershipId.find(
                                (obj) => obj.type === "camping"
                              );
                              const gardenTourId = gardenTourObj
                                ? gardenTourObj.id
                                : null;
                              setState({
                                ...state,
                                other_memberships_included: e.target.checked
                                  ? gardenTourId
                                    ? gardenTourId
                                    : e.target.checked
                                  : null,
                              });
                              if (e.target.checked && gardenTourId) {
                              }
                            }}
                            type="checkbox"
                            checked={state.other_memberships_included || false}
                          />

                          <span>
                            Add Camping to the package. (extra charges included)
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 addCampingRadio">
                    <div className="row">
                      <div className="col-md-12">
                        <label
                          htmlFor="gender"
                          className="for_radio sub-title-sm"
                        >
                          <input
                            onChange={(e) => {
                              setState({
                                ...state,
                                is_family_membership: e.target.checked ? 1 : 0,
                              });
                            }}
                            type="checkbox"
                            id="gender"
                          />
                          <span>I have a Family Membership</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {Token ? (
                  <>
                    <p className="sub-title">Payment Details </p>
                    <StripeForm
                      styling={styling}
                      paynow="SUBMIT"
                      PaymentHandler={PlaceOrderHandler}
                      loading={loading}
                    />
                  </>
                ) : (
                  <>
                    <p className="sub-title">Payment Details </p>
                    <div className="camping_btn">
                      <button
                        onClick={() => {
                          navigate("/login");
                        }}
                        className="btn"
                      >
                        Sign In
                        <img src={arrow} className="image-fluid pl-2" />
                      </button>
                      <button
                        onClick={() => {
                          navigate("/signup");
                        }}
                        className="btn secondbtn"
                      >
                        Create An Account
                        <img src={arrow} className="image-fluid pl-2" />
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </>
  );
}

export default GardenTour;
